import { getAtomWithStorage } from 'src/utils/localStorageUtils';

export const visitorBirthAtom = getAtomWithStorage<string | null>('visitorBirth', null);
